import {
  ShieldCheckIcon,
  AwardIcon,
  UsersIcon,
  ClipboardCheckIcon,
  LanguagesIcon,
  ClockIcon,
} from 'lucide-react'
import type { Feature } from '../types/content'

export const features: Feature[] = [
  {
    icon: ShieldCheckIcon,
    title: { en: 'Licensed & Insured', es: 'Con Licencia y Asegurados' },
    description: {
      en: 'Fully licensed and insured for every job, so your property and our crew are protected from day one.',
      es: 'Totalmente licenciados y asegurados en cada trabajo, para proteger tu propiedad y a nuestro equipo desde el primer día.',
    },
  },
  {
    icon: AwardIcon,
    title: { en: '10+ Years of Experience', es: '10+ Años de Experiencia' },
    description: {
      en: 'A decade of painting, drywall and remodeling across Dallas-Fort Worth — residential and commercial.',
      es: 'Una década de pintura, drywall y remodelación en Dallas-Fort Worth — residencial y comercial.',
    },
  },
  {
    icon: UsersIcon,
    title: { en: 'Family Owned & Operated', es: 'Negocio Familiar' },
    description: {
      en: 'You deal directly with the owners. The person who quotes your job is on site while it gets done.',
      es: 'Tratas directamente con los dueños. Quien cotiza tu trabajo está presente mientras se realiza.',
    },
  },
  {
    icon: ClipboardCheckIcon,
    title: { en: 'Free Estimates & Quality Guarantee', es: 'Presupuesto Gratis y Garantía' },
    description: {
      en: 'Free on-site consultation, honest competitive pricing, and workmanship we stand behind in writing.',
      es: 'Consulta gratis en sitio, precios honestos y competitivos, y mano de obra garantizada por escrito.',
    },
  },
  {
    icon: LanguagesIcon,
    title: { en: 'Bilingual Service', es: 'Servicio Bilingüe' },
    description: {
      en: 'English and Spanish on every call and every job site — nothing gets lost in translation.',
      es: 'Inglés y español en cada llamada y en cada obra — nada se pierde en la traducción.',
    },
  },
  {
    icon: ClockIcon,
    title: { en: 'Fast & Efficient Service', es: 'Servicio Rápido y Eficiente' },
    description: {
      en: 'Same-day estimates when we can, clear schedules, and crews that finish when we said we would.',
      es: 'Presupuestos el mismo día cuando es posible, horarios claros y equipos que terminan cuando prometen.',
    },
  },
]
